@import '../../../../../../../static/less/variables';
@import '~bootstrap/less/mixins.less';
@import '~react-bootstrap-switch/src/less/bootstrap3/react-bootstrap-switch.less';
@import '~react-bootstrap-daterangepicker/css/daterangepicker.css';

.c-datepicker {
  font-weight: 600;
  font-size: 15px;
  //max-width: 370px;
  min-height: 46px;
  text-align: left;
  .caret {
    margin-left: 5px;
    vertical-align: middle;
  }
  .glyphicon {
    margin-right: 5px;
  }
}

.daterangepicker {
  table {
    td.active,
    td.active:hover {
      background-color: @pipl-link-color-selected;
      //border-color: @pipl-link-color-selected;
    }
  }
  .range_inputs {
    button {
      width: 48%;
    }
  }
  .ranges {
    ul li {
      &:hover {
        color: #fff;
        font-weight: bold;
        background: @pipl-link-color-selected;
        border: 1px solid @pipl-link-color-selected;
      }
      &.active {
        color: @pipl-blue;
        font-weight: bold;
        background: #fff;
        border: 1px solid @pipl-link-color-selected;
      }
      background: #fff;
      cursor: pointer;
      line-height: 22px;
      border: 1px solid #ccc;
      color: @pipl-dark-gray;
    }
  }
}

.o-history-dropdown {
  .dropdown-menu {
    > li > a {
      font-size: 15px;
      line-height: 46px;
      color: #546073;
      padding: 3px 45px;
      &:hover {
        background-color: @pipl-blue;
        color: #fff;
      }
    }
  }
}

.o-history-item__date {
  display: inline-block;
  vertical-align: top;
  margin-right: 30px;
  width: 20%;
}

.o-history-item__query {
  &.single {
    width: 68%;
  }
  width: 38%;
  display: inline-block;
  vertical-align: top;
  .o-history-item__query_less {
    float: left;
    width: 90%;
  }
  &.is-cache {
    .o-history-item__query_less {
      color: #546073;
    }
    .o-history-item__query_details .query-note {
      color: #546073;
    }
  }
  &.is-error {
    .o-history-item__query_less {
      color: #d9534f;
    }
    .o-history-item__query_details .query-note {
      color: #d9534f;
    }
  }
  &.open {
    .o-history-item__query_details {
      display: block;
      width: 90%;
      float: left;
    }
    .o-history-item__query_less {
      display: none;
    }
  }

  .o-history-item__query_details {
    display: none;
    .query:first-child {
      .query-label {
        padding-top: 0;
      }
    }
  }
  .query {
    display: table-row;
    margin-bottom: 10px;
  }
  .query-label {
    min-width: 110px;
    color: @pipl-dark-gray;
    display: table-cell;
    text-transform: uppercase;
    padding-right: 10px;
    padding-top: 10px;
  }
  .query-data {
    display: table-cell;
  }
}

.o-history-item__username {
  width: 25%;
  display: inline-block;
  vertical-align: top;
  margin-right: 30px;
}

.o-history-item__action {
  width: 70px;
  text-align: left;
  float: right;
  vertical-align: top;
  position: relative;
  a {
    color: @pipl-blue;
  }
}

.o-history-item:hover {
  .o-history-item__action {
    display: inline-block;
  }
}

.icon_duplicate_search {
  background: url('../../../../../../../static/img/icon_duplicate_search.png') center;
  background-size: 22px 22px;
  width: 22px;
  height: 18px;
  display: inline-block;
}

.icon_search_again {
  margin-right: 15px;
  background: url('../../../../../../../static/img/icon_search_again_grey.png') center;
  background-size: 22px 22px;
  width: 22px;
  height: 20px;
  display: block;
  &:hover {
    background-image: url('../../../../../../../static/img/icon_search_again_blue.png');
  }
}

.icon_search_detail {
  background: url('../../../../../../../static/img/icon_search_detail_grey.png') center;
  background-size: 22px 22px;
  width: 22px;
  height: 20px;
  display: block;
  &:hover {
    background-image: url('../../../../../../../static/img/icon_search_detail_blue.png');
  }
}

.icon_search_less {
  background: url('../../../../../../../static/img/icon_search_less_grey.png') center;
  background-size: 22px 22px;
  width: 22px;
  height: 20px;
  display: block;
  &:hover {
    background-image: url('../../../../../../../static/img/icon_search_less_blue.png');
  }
}

@media screen and (max-width: @screen-sm-max) {
  .o-history-item__query,
  .o-history-item__username,
  .o-history-item__date,
  .o-history-item__action {
    width: 80%;
    padding: 0;
    margin-bottom: 5px;
  }

  .o-history-item__action {
    float: none;
    display: inline-block;

    text-align: left;
    a {
      width: unset !important;
    }
  }

  .o-history-item {
    position: relative;
  }
}

@media screen and (max-width: @screen-xs-max) {
  .c-datepicker-wrapper {
    overflow: hidden;
    width: 100%;
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/ManagementPanel/routes/History/components/History.less